import classnames from 'classnames';

import { CmsComparison, CmsComparisonImage } from '@interfaces/common';
import { breakpoints } from '@utils/device';
import { getVisualSize } from '@utils/visual';

import styles from './ComparisonItem.module.css';

type ComparisonItemProps = Omit<CmsComparison, '_key'>;

const getImageString = (image: CmsComparisonImage) =>
	image === 'burger' ? 'burger' : 'cow-side';

export const ComparisonItem: React.VFC<ComparisonItemProps> = ({
	color,
	pointOfComparison,
	name,
	barSizePercentage,
	image,
	imageRotation,
}) => {
	const customProperties = {
		'--comparison-item-text-color':
			color === 'green'
				? 'var(--color-core-black)'
				: 'var(--color-core-dark-grey)',
		'--comparison-item-color':
			color === 'green'
				? 'var(--color-future-green)'
				: 'var(--color-core-dark-grey)',
		'--comparison-item-image-rotation': `${
			imageRotation === 'left' ? -12 : 19
		}deg`,
		'--comparison-item-bar-desktop-width': `${barSizePercentage}%`,
		// Calculating percentage of bar max height (50 rem)
		'--comparison-item-bar-mobile-height': `${
			(barSizePercentage / 100) * 50
		}rem`,
	} as React.CSSProperties;

	const imageString = getImageString(image);

	return (
		<article className={styles.wrapper} style={customProperties}>
			<div className={styles['bar-wrapper']}>
				<img
					alt=""
					className={classnames(styles.image, styles[imageString])}
					height={getVisualSize(imageString).height}
					loading="lazy"
					sizes={`${breakpoints.lg} 160px, 120px`}
					src={`/img/${imageString}/${imageString}.png`}
					srcSet={`/img/${imageString}/${imageString}-160.webp 160w, /img/${imageString}/${imageString}-120.webp 120w, /img/${imageString}/${imageString}-320.webp 320w`}
					width={getVisualSize(imageString).width}
				/>
				<div className={styles.bar} />
			</div>
			<div className={classnames(styles.data, 'stack-block')}>
				<div className="fluid-font-t2">{pointOfComparison}</div>
				<h3 className="fluid-font-t6-bold">{name}</h3>
			</div>
		</article>
	);
};
